import { DashboardType } from '@squaredup/dashboards';
import { useAppContext } from 'contexts/AppContext';
import { dashboardQueryKeys } from 'queries/queryKeys/dashboardKeys';
import { scopeQueryKeys } from 'queries/queryKeys/scopeKeys';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router';
import { CreatePluginDashboard } from 'services/PluginService';

export const useCreateOobDashboard = (pluginId: string, configId: string, dashboardPath: string) => {
    const { currentWorkspaceID } = useAppContext();
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const { mutate: createDashboard, isLoading: isCreatingDashboard } = useMutation({
        mutationFn: () => {
            return CreatePluginDashboard(pluginId, configId, currentWorkspaceID ?? '', dashboardPath ?? '');
        },
        onSuccess: (newDashboard: DashboardType) => {
            queryClient.resetQueries(scopeQueryKeys.workspace(currentWorkspaceID));

            queryClient.setQueriesData<DashboardType[]>(dashboardQueryKeys.list, (data) => [
                ...(data || []),
                newDashboard
            ]);

            navigate(`/dashboard/${newDashboard.id}`);
        }
    });

    return {
        createDashboard,
        isCreatingDashboard
    };
};
